const TitleSection = ({ titleSectionData, sectionClasses, headingClasses, subTitle, title, headingTag }) => {
  // Accept either a structured prop (`titleSectionData`) or the simpler
  // shape (`title` + optional `subTitle`) the projects page uses.
  // `headingTag` defaults to h2 so the homepage can keep a single h1 (in
  // the hero) and inner pages still emit a clean h2-h3 hierarchy. Pass
  // `headingTag="h1"` if a consumer genuinely needs to be the page's h1.
  //
  // The overline (e.g. "About Us", "FAQ", "Our Developments") is a visual
  // category label that introduces the section title — it is NOT a heading.
  // Rendering it as <h6> was a skip-level violation since no H2-H5 sit
  // between the page H1 and this overline. We render it as a <span>
  // instead so only the actual section title (the HeadingTag) lands in
  // the document outline.
  const HeadingTag = headingTag || "h2";
  const headingSub = subTitle ?? titleSectionData?.subTitle ?? "";
  const headingTitle = title ?? titleSectionData?.title ?? "";
  return (
    <>
      <div className={`section-title-area ${sectionClasses}`}>
        {headingSub ? (
          <span
            className={`section-subtitle ${headingClasses} ltn__secondary-color`}
          >
            {headingSub}
          </span>
        ) : null}
        <HeadingTag className="section-title"> {headingTitle}</HeadingTag>
      </div>
    </>
  );
};

export default TitleSection;
